import {Col, Row} from 'antd'
import { ProviderValue, useAxios } from '../../config/axios-config'
import { DinneyAdminRequestDTO } from '../../model/DinneyAdminRequestDTO'
import {AccountResponseDTO, DinneyAdminResponseDTO} from '../../model/ResponsesDTO'
import { useState } from 'react'
import {AccountRequestDTO} from "../../model/AccountRequestDTO";
import {Form} from "react-bootstrap";

export const DinneyAdminPage = () => {

    const axiosInstance = useAxios() as ProviderValue
    const controller = new AbortController();
    const [inputId, setInputId] = useState<string>("")
    const [failedCustomers, setFailedCustomers] = useState<string[]>([])
    const signal = controller.signal
    
    const handleMigratePaymentSummary = async () => {
        var request = new DinneyAdminRequestDTO()
        await axiosInstance.post<DinneyAdminResponseDTO>(`/dinneyadmin/secure/migrate`, request, {signal}).then((response) => {
            setFailedCustomers(response.data.uncreatedCustomers)
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    const handleRemoveOldData = async () => {
        var request = new DinneyAdminRequestDTO()
        await axiosInstance.post<DinneyAdminResponseDTO>(`/dinneyadmin/secure/removeolddata`, request, {signal}).then((response) => {
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    const handleAddNewData = async () => {
        var request = new DinneyAdminRequestDTO()
        await axiosInstance.post<DinneyAdminResponseDTO>(`/dinneyadmin/secure/addnewdata`, request, {signal}).then((response) => {
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    const handleRemoveOldMenuWeeks = async () => {
        var request = new DinneyAdminRequestDTO()
        await axiosInstance.post<DinneyAdminResponseDTO>(`/dinneyadmin/secure/removemenuweeks`, request, {signal}).then((response) => {
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    const handleCreateTestAccount = async () => {
        var request = new AccountRequestDTO("Testowe konto", "testacc@testacc.pl", parseInt(inputId))
        await axiosInstance.post<AccountResponseDTO>(`/accounts/secure/create/parent`, request, {signal}).then((response) => {
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    const handleRemoveFromProvider = async () => {
        var request = new AccountRequestDTO("Testowe konto", "testacc@testacc.pl", parseInt(inputId))
        await axiosInstance.post<AccountResponseDTO>(`/dinneyadmin/secure/removeaccountfromprovider`, request, {signal}).then((response) => {
            console.log(response)
        }).catch((e) => {
            console.log(e.response?.data?.message === undefined ? e : e.response?.data?.message)
        })
    }

    return (
        <Col >
            <Row>
                <button className='button-65 my-2' onClick={() => handleMigratePaymentSummary()}>
                Dodaj PaymentSummary do starych kont
                </button>
            </Row>
            <Row>
                {failedCustomers}
            </Row>
            <Row>
                <button className='button-65 my-2' onClick={() => handleRemoveOldData()}>
                    Usuń nieaktywnych klientów
                </button>
            </Row>
            <Row>
                <button className='button-65 my-2' onClick={() => handleAddNewData()}>
                    Dodaj nowe dane do aktywnych klientów
                </button>
            </Row>
            <Row>
                <button className='button-65 my-2' onClick={() => handleRemoveOldMenuWeeks()}>
                    Usuń stare posiłki tygodniowe
                </button>
            </Row>
            <Row>
                <Col>
                    <button className='button-65 my-2' onClick={() => handleCreateTestAccount()}>
                        Stwórz testowe konto
                    </button>
                </Col>
                <Col>
                    <Form.Control
                        type="text"
                        value={inputId}
                        placeholder="Podaj id"
                        onChange={(e) => setInputId(e.target.value)}
                    />
                </Col>
            </Row>
            <Row>
                <button className='button-65 my-2' onClick={() => handleRemoveFromProvider()}>
                    Usuń konto z Auth0
                </button>
            </Row>
        </Col>
    )
}